const fetchData = async (url: string, params: object = {}, isJson: boolean = true) => {
  try {
    const response = await fetch(url, params);
    // бэкенд в некоторых эндпойнтах присылает пустой ответ
    // чтобы обработать эту ситуацию, приходится сначала конвертировать body ответа в строку
    // response.json() в этой ситуации выкидывал бы ошибку.
    // При этом в некоторых случаях вообще нельзя вызывать JSON.parse, т.к. бэкенд возвращает строковый ответ,
    // который не является валидным json-ом
    const body = (await response.text()) || '';
    const json = body && isJson ? JSON.parse(body) : body;

    if (json.status >= 400 || response.status >= 400) {
      return Promise.reject(
        json ? {
          ...json,
          status: json.status || response.status,
        } : {
          status: response.status,
        }
      );
    } else {
      return Promise.resolve(json);
    }
  } catch (error) {
    return Promise.reject(error);
  }
};

export default fetchData;
